import { TBundleLineInState } from './bundle-line-in-db.models';
import { TBundleLineInActions } from './bundle-line-in-db.actions';

export const bundleLineInStoreInitalState: TBundleLineInState = {
  transactionLogInfo: null,
  activityLogInfo: null,
  restoreCount: 0,
};

export function bundleLineInStoreStateReducer(
  state: TBundleLineInState = bundleLineInStoreInitalState,
  action: TBundleLineInActions,
): TBundleLineInState {
  switch (action.type) {
    case 'GET_TRANSACTION_LOG_BUNDLE_LINE_IN_SUCCESS':
      return {
        ...state,
        transactionLogInfo: action.transactionLog,
      };
    case 'GET_ACTIVITY_LOG_BUNDLE_LINE_IN_SUCCESS':
      return {
        ...state,
        activityLogInfo: action.activityLog,
      };
    case 'GET_RESTORE_COUNT_BUNDLE_LINE_IN_SUCCESS':
      return {
        ...state,
        restoreCount: action.restoreData.quantity_scanned,
      };
    default:
      return state;
  }
}
